.filterButton {
  text-transform: var(--haus-facetFiltersDropdown__filterButton__text-transform, capitalize);
  border: var(--haus-facetFiltersDropdown__filterButton__border, none);
  padding: var(--haus-facetFiltersDropdown__filterButton__padding, 0);
  border-radius: var(--haus-facetFiltersDropdown__filterButton__border-radius, 0);
  background: var(--haus-facetFiltersDropdown__filterButton__background, transparent);
  color: var(--haus-facetFiltersDropdown__filterButton__color, var(--haus-color-body));
  font-family: var(
    --haus-facetFiltersDropdown__filterButton__font-family,
    var(--haus-typography-body-font-family)
  );
  font-weight: var(--haus-facetFiltersDropdown__filterButton__font-weight, 700);
  font-size: var(--haus-facetFiltersDropdown__filterButton__font-size, 16px);

  &:hover {
    border: var(--haus-facetFiltersDropdown__filterButton__hover__border, none) !important;
    background: var(
      --haus-facetFiltersDropdown__filterButton__hover__background,
      transparent
    ) !important;
    color: var(
      --haus-facetFiltersDropdown__filterButton__hover__color,
      var(--haus-color-body)
    ) !important;
    font-family: var(
      --haus-facetFiltersDropdown__filterButton__hover__font-family,
      var(--haus-typography-body-font-family)
    ) !important;
    font-weight: var(--haus-facetFiltersDropdown__filterButton__hover__font-weight, 700) !important;
    outline: var(--haus-facetFiltersDropdown__filterButton__hover__outline, none) !important;
  }

  &:focus-visible {
    outline: var(
      --haus-facetFiltersDropdown__filterButton__focus-visible__outline,
      2px solid var(--haus-color-primary, #000)
    ) !important;
    outline-offset: var(
      --haus-facetFiltersDropdown__filterButton__focus-visible__outline-offset,
      2px
    );
  }
}

.dropdownContent {
  background: var(--haus-facetFiltersDropdown__dropdownContent__background, #fff);
  border: var(--haus-facetFiltersDropdown__dropdownContent__border, 1px solid #e5e7eb);
  border-radius: var(--haus-facetFiltersDropdown__dropdownContent__border-radius, 8px);
  padding: var(--haus-facetFiltersDropdown__dropdownContent__padding, 12px);
  min-width: var(--haus-facetFiltersDropdown__dropdownContent__min-width, 260px);
  z-index: var(--haus-facetFiltersDropdown__dropdownContent__z-index, 9999);
}

.facetDropdownContent {
  overflow: var(
    --haus-facetFiltersDropdown__facetDropdownContent__overflow,
    visible
  ); /* was auto; prevents clipping inner shadow */
  background: var(--haus-facetFiltersDropdown__facetDropdownContent__background, transparent);
  border: var(--haus-facetFiltersDropdown__facetDropdownContent__border, none);
  padding: var(--haus-facetFiltersDropdown__facetDropdownContent__padding, 8px);
}

.filtersGroupContent {
  border-radius: var(--haus-facetFiltersDropdown__filtersGroupContent__border-radius, 8px);
  max-height: var(--haus-facetFiltersDropdown__filtersGroupContent__max-height, 500px);
  overflow: var(--haus-facetFiltersDropdown__filtersGroupContent__overflow, auto);
  box-sizing: var(--haus-facetFiltersDropdown__filtersGroupContent__box-sizing, border-box);
  max-width: var(--haus-facetFiltersDropdown__filtersGroupContent__max-width, 100vw);
  display: var(--haus-facetFiltersDropdown__filtersGroupContent__display, grid);
  gap: var(--haus-facetFiltersDropdown__filtersGroupContent__gap, 10px);
}

.inputGrid {
  display: var(--haus-facetFiltersDropdown__inputGrid__display, grid);
  gap: var(--haus-facetFiltersDropdown__inputGrid__gap, 8px);
}

.sliderGrid {
  display: var(--haus-facetFiltersDropdown__sliderGrid__display, grid);
  gap: var(--haus-facetFiltersDropdown__sliderGrid__gap, 8px);
}

.priceSlider {
  display: var(--haus-facetFiltersDropdown__priceSlider__display, grid);
  gap: var(--haus-facetFiltersDropdown__priceSlider__gap, 12px);
}

.priceValues {
  display: var(--haus-facetFiltersDropdown__priceValues__display, flex);
  gap: var(--haus-facetFiltersDropdown__priceValues__gap, 8px);
  font-weight: var(--haus-facetFiltersDropdown__priceValues__font-weight, 600);
  flex-direction: var(--haus-facetFiltersDropdown__priceValues__flex-direction, row);
  justify-content: var(--haus-facetFiltersDropdown__priceValues__justify-content, center);
  align-items: var(--haus-facetFiltersDropdown__priceValues__align-items, center);
}

.srOnly {
  position: var(--haus-facetFiltersDropdown__srOnly__position, absolute) !important;
  width: var(--haus-facetFiltersDropdown__srOnly__width, 1px) !important;
  height: var(--haus-facetFiltersDropdown__srOnly__height, 1px) !important;
  padding: var(--haus-facetFiltersDropdown__srOnly__padding, 0) !important;
  margin: var(--haus-facetFiltersDropdown__srOnly__margin, -1px) !important;
  overflow: var(--haus-facetFiltersDropdown__srOnly__overflow, hidden) !important;
  clip: var(--haus-facetFiltersDropdown__srOnly__clip, rect(0, 0, 0, 0)) !important;
  white-space: var(--haus-facetFiltersDropdown__srOnly__white-space, nowrap) !important;
  border: var(--haus-facetFiltersDropdown__srOnly__border, 0) !important;
}

.checkboxItem {
  display: var(--haus-facetFiltersDropdown__checkboxItem__display, flex);
  align-items: var(--haus-facetFiltersDropdown__checkboxItem__align-items, center);
  gap: var(--haus-facetFiltersDropdown__checkboxItem__gap, 10px);
  padding: var(--haus-facetFiltersDropdown__checkboxItem__padding, 8px);
  border-radius: var(--haus-facetFiltersDropdown__checkboxItem__border-radius, 8px);
  font-size: var(--haus-facetFiltersDropdown__checkboxItem__font-size, 14px);
  line-height: var(--haus-facetFiltersDropdown__checkboxItem__line-height, 1.2);
  color: var(--haus-facetFiltersDropdown__checkboxItem__color, var(--haus-color-body));
  font-family: var(
    --haus-facetFiltersDropdown__checkboxItem__font-family,
    var(--haus-typography-body-font-family)
  );

  &:hover {
    background-color: var(
      --haus-facetFiltersDropdown__checkboxItem__hover__background-color,
      #f6f6f6
    );
    border-radius: var(--haus-facetFiltersDropdown__checkboxItem__hover__border-radius, 8px);
    box-shadow: var(--haus-facetFiltersDropdown__checkboxItem__hover__box-shadow, none);
    cursor: var(--haus-facetFiltersDropdown__checkboxItem__hover__cursor, pointer);
    outline: var(--haus-facetFiltersDropdown__checkboxItem__hover__outline, none);
  }
}

.checkboxRoot {
  flex: var(--haus-facetFiltersDropdown__checkboxRoot__flex, 0 0 20px);
  background-color: var(--haus-facetFiltersDropdown__checkboxRoot__background-color, #fff);
  width: var(--haus-facetFiltersDropdown__checkboxRoot__width, 20px);
  height: var(--haus-facetFiltersDropdown__checkboxRoot__height, 20px);
  border-radius: var(--haus-facetFiltersDropdown__checkboxRoot__border-radius, 4px);
  display: var(--haus-facetFiltersDropdown__checkboxRoot__display, flex);
  align-items: var(--haus-facetFiltersDropdown__checkboxRoot__align-items, center);
  justify-content: var(--haus-facetFiltersDropdown__checkboxRoot__justify-content, center);
  box-shadow: var(--haus-facetFiltersDropdown__checkboxRoot__box-shadow, none);
  border: 1px solid var(--haus-facetFiltersDropdown__checkboxRoot__border, rgba(0, 0, 0, 0.1));
  padding: var(--haus-facetFiltersDropdown__checkboxRoot__padding, 0);

  &:hover {
    box-shadow: var(--haus-facetFiltersDropdown__checkboxRoot__hover__box-shadow, none);
    cursor: var(--haus-facetFiltersDropdown__checkboxRoot__hover__cursor, pointer);
  }

  &:focus-visible {
    outline: var(
      --haus-facetFiltersDropdown__checkboxRoot__focus-visible__outline,
      2px solid var(--haus-color-primary, #000)
    );
    outline-offset: var(
      --haus-facetFiltersDropdown__checkboxRoot__focus-visible__outline-offset,
      2px
    );
  }

  &[data-state='checked'] {
    background-color: var(
      --haus-facetFiltersDropdown__checkboxRoot__checked__background-color,
      var(--haus-color-body)
    );
    border-color: var(
      --haus-facetFiltersDropdown__checkboxRoot__checked__border-color,
      var(--haus-color-body)
    );
    box-shadow: var(--haus-facetFiltersDropdown__checkboxRoot__checked__box-shadow, none);
    color: var(--haus-facetFiltersDropdown__checkboxRoot__checked__color, #fff);
  }
}

.checkboxIndicator {
  width: var(--haus-facetFiltersDropdown__checkboxIndicator__width, 100%);
  height: var(--haus-facetFiltersDropdown__checkboxIndicator__height, 100%);
  color: var(--haus-facetFiltersDropdown__checkboxIndicator__color, #fff);
  display: var(--haus-facetFiltersDropdown__checkboxIndicator__display, flex);
  align-items: var(--haus-facetFiltersDropdown__checkboxIndicator__align-items, center);
  justify-content: var(--haus-facetFiltersDropdown__checkboxIndicator__justify-content, center);
}
